import { CONTACT } from "../../data";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-void" data-testid="site-footer">
    <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-16 md:py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <a href="#top" className="inline-block mb-6">
            <img src="/logo-light.png" alt="Scientific Industries" className="h-11 w-auto" />
          </a>
          <p className="text-plasma/55 max-w-sm leading-relaxed text-sm">
            Dependable power management and sustainable energy solutions for residential,
            commercial and industrial applications since {CONTACT.since}.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-forge mb-5">Systems</div>
          <ul className="space-y-3 text-sm text-plasma/60">
            <li><a href="#products" className="hover:text-forge transition-colors">Voltage Stabilizers</a></li>
            <li><a href="#products" className="hover:text-forge transition-colors">Servo Stabilizers</a></li>
            <li><a href="#products" className="hover:text-forge transition-colors">Solar Power Systems</a></li>
            <li><a href="#products" className="hover:text-forge transition-colors">Inverter & Battery</a></li>
            <li><a href="#products" className="hover:text-forge transition-colors">Water Coolers</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-forge mb-5">Contact</div>
          <ul className="space-y-3 text-sm text-plasma/60 font-mono">
            <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-forge transition-colors">{CONTACT.phone}</a></li>
            <li><a href={`tel:${CONTACT.phone2.replace(/\s/g, "")}`} className="hover:text-forge transition-colors">{CONTACT.phone2}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="hover:text-forge transition-colors">{CONTACT.email}</a></li>
            <li className="max-w-xs">{CONTACT.address}</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-plasma/40">
        <span>© {new Date().getFullYear()} Scientific Industries. All rights reserved.</span>
        <span>Engineered for uptime · Est. {CONTACT.since}</span>
      </div>
    </div>
  </footer>
);
